import { useEffect } from 'react'
import articleSearchTagsEvents from '../../events/articleSearchTags.events'
import ArticleSearchTagModalContent from '../ArticleSearchTagModalContent'
import useArticleSearchTag from '../../hooks/useArticleSearchTag'
import useHttpLoader from '../../../../../../../shared/hooks/useHttpLoader'
import useStateWithChange from '../../../../../../../shared/hooks/useStateWithChange'
import { IFaqArticleSearchTag } from '../../../../faq.types'
import faqApi from '../../../../faq.api'
import eventBus from '../../../../../../../services/eventBus'

interface IArticleSearchTagModalProps {
  onClose: () => void
  tagId: number
}

const ArticleSearchTagModal = ({ onClose, tagId }: IArticleSearchTagModalProps) => {
  const tag = useArticleSearchTag(Number(tagId))

  const { wait, loading } = useHttpLoader()

  const [state, setState, handleChange] = useStateWithChange<IFaqArticleSearchTag>(tag.tag)

  useEffect(() => {
    if (tag.tag) {
      setState(tag.tag)
    }
  }, [tag.tag])

  const handleSave = () => {
    wait(faqApi.updateArticleSearchTag(Number(tagId), { name: state.name.trim() }), (resp) => {
      if (resp.status === 'success') {
        articleSearchTagsEvents.updated(resp.body, Number(tagId))
        eventBus.pub('ntf.message', { message: 'Тег обновлен', type: 'info' })
        onClose()
      }
    })
  }

  return (
    <ArticleSearchTagModalContent
      title='Редактирование поискового тега'
      onClose={onClose}
      onChange={handleChange}
      onSave={handleSave}
      state={state}
      loading={loading || tag.loading}
    />
  )
}

export default ArticleSearchTagModal
